import {
    DecisionPendingClarification,
    MedicalOutcome,
    MedicalOutcomeModel,
    MedicalType,
    MedicalTypeIds,
    medicalTypes
} from "@teamprevent/common/healthSurveillance/models";
import { TaskModel, TaskTypes } from "@teamprevent/common/task/taskActions/models";

import { MedicalOutcomes } from "../../task/model";

export interface MedicalOutcomeFormModel {
    values: MedicalOutcomeModel;
    valid: boolean;
}

export const mapMedicalTypesToOutcomes = (types: MedicalType[]): MedicalOutcomes => {
    return (types ?? []).map(t => (
        { values: {
            medicalTypeId: t.id,
            clinicalNotes: "",
            customerNotes: "",
            outcome: null as unknown as MedicalOutcome,
            decisionPendingClarification: null as unknown as DecisionPendingClarification,
        }, valid: false, medicalType: t }
    ));
};

export const adjustMedicalTypes = (types: MedicalType[], reviewTask: TaskModel | undefined): MedicalType[] => {
    const isReviewHealthSurveillanceResultsFromRepeatMedicalTask = reviewTask?.type === TaskTypes.ReviewHealthSurveillanceResultsFromRepeatMedicalTask;
    const ohCaseContainsRespiratorySensitiserQuestionnaireLevel1 = types?.some(mt => mt.id === MedicalTypeIds.RespiratorySensitiserQuestionnaireLevel1);
    const ohCaseContainsRespiratorySensitiserFaceToFaceLevel1 = types?.some(mt => mt.id === MedicalTypeIds.RespiratorySensitiserFaceToFaceLevel1);

    if (isReviewHealthSurveillanceResultsFromRepeatMedicalTask &&
        ohCaseContainsRespiratorySensitiserQuestionnaireLevel1 &&
        !ohCaseContainsRespiratorySensitiserFaceToFaceLevel1) {
        const respiratorySensitiserFaceToFaceLevel1MedicalType: MedicalType =
            medicalTypes.find(mt => mt.id === MedicalTypeIds.RespiratorySensitiserFaceToFaceLevel1);

        return [...types, respiratorySensitiserFaceToFaceLevel1MedicalType];
    }

    return types;
};
